<template>
  <div class="contai_h">
    <div class="cont_cont">
      <el-breadcrumb separator="/" class="cons">
        <el-breadcrumb-item>仓库管理</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/ware">入库确认</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="cont_tabs">
      <el-tabs type="border-card" @tab-click="ces">
        <!-- 建当入库 -->
        <el-tab-pane label="建当待入库">
          <el-table :data="items" border style="width: 100%">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handle(scope.row._id)" type="text" size="small"
                  >确认入库</el-button
                >
              </template>
            </el-table-column>

            <el-table-column prop="deta" label="建档日期" width="180"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="120">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100"> </el-table-column>
            <el-table-column prop="telnumber" label="电话" width="150"> </el-table-column>
            <el-table-column prop="objname" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="speci" label="规格/状况" width="150">
            </el-table-column>
            <el-table-column prop="weight" label="重量/g" width="100"> </el-table-column>
            <el-table-column prop="startdate" label="开始日期" width="120">
            </el-table-column>
            <el-table-column prop="enddate" label="终止日期" width="120">
            </el-table-column>
            <el-table-column prop="reviewdate" label="复核日期" width="150">
            </el-table-column>
            <el-table-column prop="cardnumber" label="证件号码" width="200">
            </el-table-column>
            <el-table-column prop="address" label="地址" width="280"> </el-table-column>
            <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
            <el-table-column prop="review" label="复核" width="120"> </el-table-column>
            <el-table-column prop="finance" label="财务/付款人" width="120">
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 断当回收 -->
        <el-tab-pane label="回收待入库">
          <el-table :data="shitems" border style="width: 100%">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row._id)" type="text" size="small"
                  >确认入库</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="input_pnum" label="票号" width="130">
            </el-table-column>
            <el-table-column prop="deta" label="建档日期" width="150"> </el-table-column>
            <el-table-column prop="input_names" label="姓名" width="90">
            </el-table-column>
            <el-table-column prop="input_tels" label="电话" width="150">
            </el-table-column>
            <el-table-column prop="tabs_inputs" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="tabs_inpus" label="规格/状况" width="150">
            </el-table-column>
            <el-table-column prop="tabs_ins" label="重量/g" width="100">
            </el-table-column>
            <el-table-column prop="tabs_inps" label="数量" width="80"> </el-table-column>
            <el-table-column prop="tabs_is" label="回收价格" width="100">
            </el-table-column>
            <el-table-column prop="reviewdate" label="复核日期" width="150">
            </el-table-column>
            <el-table-column prop="inputzf" label="支付备注" width="180">
            </el-table-column>
            <el-table-column prop="input_idcards" label="证件号码" width="200">
            </el-table-column>
            <el-table-column prop="input_adds" label="地址" width="280">
            </el-table-column>
            <el-table-column prop="agent" label="经办人" width="100"> </el-table-column>
            <el-table-column prop="review" label="复核" width="100"> </el-table-column>
            <el-table-column prop="finance" label="财务/付款人" width="100">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: "ware",

  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      id: "", //点击物品的id
      jid: "", //点击收回物品的id
      items: [], //待入库的数据
      shitems: [], //收回待入库的数据
      token: "",
      name: "", //登录账户的名字
    };
  },
  methods: {
    //请求获取建当已支付的的数据
    getdatas() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",whether:true,wareh:false,finance:_.neq("")}).limit(1000).get()',
        })
        .then((refs) => {
          if (refs.data.errcode == 0) {
            refs.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = refs.data.data;
          } else {
            this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
        });
    },

    //点击收回触发的点击事件
    ces(e) {
      if (e.index == 1) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("take_back").where({whether:true,wareh:false,finance:_.neq("")}).limit(1000).get()',
          })
          .then((rs) => {
            rs.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.shitems = rs.data.data;
          });
      }
    },
    //点击建当入库执行的方法
    handle(e) {
      this.jid = e;
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").doc("' +
            this.jid +
            '").update({data:{wareh:true}})',
        })
        .then((ace) => {
          if (ace.data.errcode == 0) {
            this.setwarehs();
          } else {
            this.$notify.error({
              title: "入库失败",
              message: "请检查token是否过期",
            });
          }

          setTimeout(() => {
            this.$router.go(0);
          }, 1500);
        });
    },

    //点击回收入库执行的方法
    handleClick(e) {
      this.id = e;
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("take_back").doc("' +
            this.id +
            '").update({data:{wareh:true}})',
        })
        .then((acf) => {
          if (acf.data.errcode == 0) {
            this.setwarehj();
          } else {
            this.$notify.error({
              title: "入库失败",
              message: "请检查token是否过期",
            });
          }

          setTimeout(() => {
            this.$router.go(0);
          }, 1500);
        });
    },

    //收回成功入库后执行的方法

    //建当成功添加入库操作人姓名
    setwarehj() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("take_back").doc("' +
            this.id +
            '").update({data:{warehrname:"' +
            this.name +
            '"}})',
        })
        .then((acj) => {
          if (acj.data.errcode == 0) {
            this.$notify({
              title: "入库成功",
              message: "该物品已成功入库！！",
              type: "success",
            });
          }
        });
    },
    //收回的成功添加入库操作人姓名
    setwarehs() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").doc("' +
            this.jid +
            '").update({data:{warehrname:"' +
            this.name +
            '"}})',
        })
        .then((ack) => {
          console.log(ack.data.errcode);
          if (ack.data.errcode == 0) {
            this.$notify({
              title: "入库成功",
              message: "该物品已成功入库！！",
              type: "success",
            });
          }
        });
    },
  },

  //钩子函数，组件挂载时
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
         //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()

  },
  //钩子函数，组件挂载完成时
  mounted() {
    setTimeout(()=>{
      this.getdatas();
  
    //获取登录的用户名
    this.name = this.userData.username
    },800)
    
  },
};
</script>
<style scoped>
.cont_cont {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.cons {
  margin: 0 20px;
}
.cont_tabs {
  margin: 20px auto;
}
</style>
